import { Component } from 'react';
import Spinner from '~/js/components/general/Spinner';
import GoFetch from '~/js/modules/fetch-wrapper';
import AccommodationCard from '~/js/components/specials/qualifying-rooms-suites/RoomsSuitesItem';
import FeatureTooltips from '~/js/components/accommodations/FeatureTooltips';

const fetch = new GoFetch();
const { bestValueData = [], urisData = {} } = window.beaches_app.page;

const internals = {};

internals.roomDetailURI = {
  bcv: '/resorts/turks-caicos/caribbean-village/',
  bfv: '/resorts/turks-caicos/french-village/',
  bit: '/resorts/turks-caicos/italian-village/',
  kwv: '/resorts/turks-caicos/keywest-village/',
  phs: '/resorts/turks-caicos/rooms/penthouse-suites/',
  sbv: '/resorts/turks-caicos/butler-villas/'
};

class QualifyingRoomsSuites extends Component {
  state = {
    roomsData: []
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    if (bestValueData.length) {

      const roomCategoryCodes = bestValueData.reduce((accu, curr) => [ ...accu, ...curr.roomCodes ], []);
      const resortCategoryPairs = bestValueData.reduce((pairs, resort) => {
        pairs.push(...resort.roomCodes.map(code => {
          return { resortCode: resort.resortCode, categoryCode: code };
        }));

        return pairs;
      }, []);

      fetch.get(`/fetchRoomData/?roomCategoryCodes=${roomCategoryCodes}`)
        .then((response) => {
          if (response.status !== 'error') {

            const { roomData = {} } = response.data;
            const filteredRooms = resortCategoryPairs.map((pair) => {
              return roomData.find((room) => room.code === pair.categoryCode && room.resortCode === pair.resortCode) || {};
            });

            this.setState({ roomsData: filteredRooms });
          } else {

            this.setState({ roomsData: null });
          }
        });
    } else {

      this.setState({ roomsData: null });
    }
  };


  _updateModal = (modalTitle = '', modalDetails = '') => () => this.setState({ modalTitle, modalDetails });

  _updateRooms = (rooms, cb) => this.setState({ rooms }, cb);

  _updateStatus = (status) => this.setState({ status });

  _updateModal = (modalTitle = '', modalDetails = '') => () => this.setState({ modalTitle, modalDetails });

  _filterRoomsBy = (rooms = []) => {
    const { villageCode = '' } = this.props;

    return rooms.filter((room) => room.groupCode === villageCode);
  };

  _updateView = (isListView = false) => () => this.setState({ isListView });


  render() {
    const { roomsData } = this.state;

    let roomsList = <Spinner />;

    if (roomsData) {
      if (roomsData.length > 0) {
        roomsList = (
          <div className="rooms-list">
            <div className="tooltip_templates hide">
              <FeatureTooltips />
            </div>
            {roomsData.map((el, index) => {
              if (el.rate !== undefined) {
                const detailsLink = urisData[`${el.resortCode.toLowerCase()}_rooms_detail`] + `?categoryCode=${el.code}`;

                return <AccommodationCard key={index} roomInformation={el} isListView={false} modalId="" updateModal={this._updateModal} villageCode={this.props.villageCode} roomDetailURI={detailsLink} />;
              }

              return (<br/>);
            })}
          </div>
        );
      }
    } else {
      roomsList = <div className="no-result">There are no qualifying rooms and suites</div>;
    }

    return roomsList;
  }
}

export default QualifyingRoomsSuites;
